import React from 'react';

const Policy = () => {
  return (
    <div className="px-4 pt-32 font-lato bg-[#fdf8f6]">
      <div className="text-center text-3xl pt-10 border-t font-cinzel  text-[#4c0f2e]">
        Our <span className="text-[#4c0f2e] ">Policy</span>
        <div className="w-20 h-1 bg-[#4c0f2e] mx-auto mt-2 rounded"></div>
      </div>

      <div className="my-12 px-6 md:px-20 text-gray-700 space-y-16 text-sm">
        {/* Product Disclaimer */}
        <section className="border-l-4 border-[#4c0f2e] pl-6 relative" id="disclaimer">
          <h2 className="text-xl font-cinzel mb-3 text-[#4c0f2e]">Product Disclaimer</h2>
          <p>Zarviya offers fashion jewelry made with premium craftsmanship. Please note:</p>
          <ul className="list-disc pl-5 space-y-2 mt-2">
            <li>Our products do not contain real gold, diamonds, or precious stones.</li>
            <li>The appearance is designed to resemble fine jewelry for aesthetic appeal.</li>
            <li>Color and finish may slightly vary due to lighting or screen settings.</li>
          </ul>
        </section>

        <section className="border-l-4 border-[#4c0f2e] pl-6 relative" id="refund">
          <h2 className="text-xl mb-3 text-[#4c0f2e]">Refunds & Cancellations</h2>
          <p>Refunds are applicable only under the following conditions:</p>
          <ul className="list-disc pl-5 space-y-2 mt-2">
            <li>You have received a damaged or defective product.</li>
            <li>You have received an incorrect item.</li>
          </ul>
          <p className="mt-3">
            Customers must report issues within 24 hours of delivery. An uncut parcel opening video
            is mandatory for verification. Approved refunds will be processed within 7 working days
            to the original payment method.
            <strong>
              {' '}
              Please note, payment gateway charges will be deducted from the refunded amount.
            </strong>{' '}
            We do not allow cancellation once the order is confirmed.
          </p>
        </section>

        <section className="border-l-4 border-[#4c0f2e] pl-6 relative" id="exchange">
          <h2 className="text-xl  mb-3 text-[#4c0f2e]">Exchange Policy</h2>
          <p>
            Exchanges are applicable only in case of wrong or defective item delivery. Products must
            be unused, with tags intact, and returned in their original packaging. All exchanges are
            subject to stock availability.
          </p>
          <p className="mt-3">
            Return shipping cost must be borne by the customer unless it was an error from our end.
          </p>
        </section>

        <section className="border-l-4 border-[#4c0f2e] pl-6 relative" id="shipping">
          <h2 className="text-xl  mb-3 text-[#4c0f2e]">Shipping Policy</h2>
          <p>
            Orders are processed and dispatched within 2–5 business days. Standard delivery
            timelines range from 5–10 days depending on the delivery location. Delays due to
            weather, logistics, or holidays may occur.
          </p>
          <p className="mt-3">
            Once your order is shipped, a tracking number will be shared via email. We are not
            liable for delays caused by courier agencies.
          </p>
        </section>

        <section className="border-l-4 border-[#4c0f2e] pl-6 relative" id="jewellery-care">
          <h2 className="text-xl font-cinzel mb-3 text-[#4c0f2e]">Jewellery Care</h2>
          <p>Our imitation jewellery is crafted with precision. To maintain its shine:</p>
          <ul className="list-disc pl-5 space-y-2 mt-2">
            <li>Avoid direct contact with water, perfumes, or chemicals.</li>
            <li>Store in a dry place, preferably in a ziplock pouch or box.</li>
            <li>Clean with a soft dry cloth after every use.</li>
          </ul>
        </section>
        <section className="border-l-4 border-[#4c0f2e] pl-6 relative" id="terms">
          <h2 className="text-xl font-cinzel mb-3 text-[#4c0f2e]">Terms & Conditions</h2>
          <div className="text-sm text-[#1f1f1f] space-y-3">
            <p>
              <strong>Last updated on Jul 2, 2025</strong>
            </p>

            <p>
              For the purpose of these Terms and Conditions, the terms{' '}
              <strong>"we", "us", "our"</strong> shall mean <strong>Zarviya</strong>. The terms{' '}
              <strong>"you", "your", "user", "visitor"</strong> refer to any individual or entity
              using our website or purchasing from us.
            </p>

            <p>
              Your use of our website and/or purchase from us is governed by the following terms:
            </p>

            <ul className="list-disc pl-5 space-y-2">
              <li>The content on this website is subject to change without prior notice.</li>
              <li>
                We do not guarantee the accuracy, completeness, performance, or suitability of the
                content. You acknowledge such information may contain errors, for which we are not
                liable.
              </li>
              <li>
                Use of any information or products is entirely at your own risk. You are responsible
                for ensuring suitability before purchase.
              </li>
              <li>
                All website materials—including design, layout, and graphics—are owned or licensed
                by us. Unauthorized reproduction is prohibited.
              </li>
              <li>Trademarks not owned by us are acknowledged appropriately.</li>
              <li>Unauthorized use of our information may lead to legal action.</li>
              <li>
                External links on our site are provided for convenience and do not signify
                endorsement.
              </li>
              <li>
                Creating a link to our website without written consent from Zarviya is not
                permitted.
              </li>
              <li>All disputes are subject to the laws of India.</li>
              <li>
                We shall not be held liable for any loss or damage resulting from the decline of
                authorization for any transaction due to the cardholder having exceeded the limit
                agreed upon with our acquiring bank.
              </li>
            </ul>
          </div>
        </section>

        <section className="border-l-4 border-[#4c0f2e] pl-6 relative" id="pricing">
          <h2 className="text-xl font-cinzel mb-3 text-[#4c0f2e]">Pricing & Availability</h2>
          <p>
            All prices listed are inclusive of applicable GST. While we strive for accuracy, pricing
            errors may occasionally occur. In such cases, we reserve the right to correct the price
            and contact you before processing your order.
          </p>
        </section>

        <section className="border-l-4 border-[#4c0f2e] pl-6 relative" id="terms">
          <h2 className="text-xl font-cinzel mb-3 text-[#4c0f2e]">Terms and Conditions</h2>
          <div className="space-y-3 text-sm">
            <p>
              By accessing and using our website, you agree to comply with all terms mentioned here.
              Zarviya reserves the right to update, modify, or replace any part of these policies
              without prior notice. Continued use of the website implies your acceptance of these
              terms.
            </p>
            <p>
              By placing an order, you confirm that all details provided by you are accurate and
              complete. You authorize Zarviya to use Razorpay or other payment gateways to process
              your transaction.
            </p>
            <p>
              All payments made via Razorpay are subject to their{' '}
              <a
                href="https://razorpay.com/terms/"
                className="text-[#4c0f2e] underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms of Service
              </a>{' '}
              and{' '}
              <a
                href="https://razorpay.com/privacy/"
                className="text-[#4c0f2e] underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
              . You agree to be bound by Razorpay’s policies during checkout and transaction
              processing.
            </p>
            <p>
              We are not responsible for any technical failure or payment issues on the gateway’s
              side. However, we will assist you in resolving any disputes or failed payments via
              Razorpay support.
            </p>

            <p>
              Using our services implies that you have read and understood our policies regarding
              product information, pricing, delivery, privacy, and care instructions.
            </p>
          </div>
        </section>

        <section className="border-l-4 border-[#4c0f2e] pl-6 relative" id="contact">
          <h2 className="text-xl font-cinzel mb-3 text-[#4c0f2e]">Contact Us</h2>
          <div className="text-sm space-y-3 text-[#1f1f1f]">
            <p>We’re here to help. Reach out to us for any support, queries, or feedback.</p>

            <p>
              <span className="font-semibold text-[#4c0f2e]">Phone:</span>{' '}
              <a href="tel:+918848899198" className="hover:underline text-gray-800">
                +91-8848899198
              </a>
            </p>

            <p>
              <span className="font-semibold text-[#4c0f2e]">Email:</span>{' '}
              <a href="mailto:contact@zarviya.com" className="hover:underline text-gray-800">
                contact@zarviya.com
              </a>
            </p>

            <p>
              <span className="font-semibold text-[#4c0f2e]">Address:</span>
              Pazhayangadi, Kannur, Kerala – 670305
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Policy;
